goog.provide('el8.util.smart');


el8.util.smart.validateIcd9Code = function(icd9) {
    return (/^(V\d{2}(\.\d{1,2})?|\d{2,3}(\.\d{1,2})?|E\d{3}(\.\d)?)$/).test(icd9);
};

el8.util.smart.isPhoneNum = function(candidateString) {
    candidateString = String(candidateString); // in case an Int gets passed in
    // regex borrowed from jquery.validate.js and modified to accept more separators
    return candidateString &&
        candidateString.match(/^(1[\.\-\s]?)?(\([1-9]\d{2}\)|[1-9]\d{2})[\.\-\s]?[1-9]\d{2}[\.\-\s]?\d{4}$/);
};

